import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import { BADGE_TOKEN_NAMES } from "./tokens"

const Badge = ({
  text,
  color = "neutral",
  onDismiss,
  icon,
  iconStyle = "kit",
  iconPlacement = "left",
  variant = "default",
}) => {
  const classes = classNames(
    "inline-block",
    "whitespace-nowrap",
    "px-2",
    "py-1",
    "font-bold",
    "rounded",
    "cursor-default",
    ...colorClasses(color),
    { "text-xs": variant === "small", "text-sm": variant === "default" }
  )

  const renderText = () => {
    if (icon) {
      return (
        <div className="flex items-center">
          {iconPlacement === "left" ? (
            <>
              <i className={`fa-${iconStyle} fa-${icon} mr-2`} />
              {text}
            </>
          ) : (
            <>
              {text}
              <i className={`fa-${iconStyle} fa-${icon} ml-2`} />
            </>
          )}
        </div>
      )
    } else {
      return text
    }
  }

  return (
    <span className={classes} data-design-system="Badge">
      <div className="flex items-center justify-between">
        {renderText()}
        {onDismiss && (
          <i
            role="button"
            aria-label="dismiss"
            className="fa-solid fa-xmark ml-2 mt-0.5 cursor-pointer rounded-full text-xs"
            onClick={onDismiss}
          />
        )}
      </div>
    </span>
  )
}

Badge.propTypes = {
  icon: PropTypes.string,
  iconStyle: PropTypes.string,
  iconPlacement: PropTypes.oneOf(["left", "right"]),
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]).isRequired,
  onDismiss: PropTypes.func,
  color: PropTypes.oneOf([...BADGE_TOKEN_NAMES, "notification"]).isRequired,
  variant: PropTypes.oneOf(["default", "small"]),
}

const colorClasses = (color) => {
  if (color === "notification") {
    return ["text-white", "bg-blue-600", "rounded-full", "text-xs"]
  }

  return [`badge-tone-${BADGE_TOKEN_NAMES.includes(color) ? color : "neutral"}`]
}

export default Badge
